export default {
  assets: {
    ui: [
      require('../assets/images/FrostBorderTop.png'),
      require('../assets/images/FrostBorderBottom.png'),
    ],
  },
}